import axios from 'axios'
import DataActions from '../core/enums/ActionTypes/DataActions'
import SidebarAction from '../core/enums/ActionTypes/SidebarAction'
import {eraseCookie, getCookie, setCookie} from '../core/helpers'
import {ServiceHub} from '../core/ServiceHub'
import {UserInfoAction} from '../enums/ActionTypes/UserInfoAction'
import {IAppStore, IAppUser, IUserInfo} from '../interfaces/reducers'
import appConfig from '../reducers/appConfig'
import {appPopupDispatcher} from './appPopupDispatcher'
import {appSidebarDispatcher} from './appSidebarDispatcher'
import {appSourcesDispatcher} from './appSourcesDispatcher'
import {setSession} from '../utils/jwt'

let interval: ReturnType<typeof setInterval>
let signinCallback: (success: boolean) => void
export const clearErrors = () => (dispatch: (data: any) => void, getStore: () => IAppStore) => {
  dispatch({
    type: UserInfoAction.CLEAR_ERROR,
    payload: {}
  })
}
export const register =
  (username: string, password: string, names: string, captchaKey: string) =>
  (dispatch: (data: any) => void, getStore: () => IAppStore) => {
    dispatch({
      type: UserInfoAction.SET_LOADING,
      payload: true
    })
    axios
      .post(appConfig.urls.publicRegisterUrl, {
        Username: username,
        Password: password,
        Names: names,
        CaptchaKey: captchaKey
      })
      .then(r => {
        const payload: IUserInfo = {
          loading: false,
          successRegistrationAwaitingConfirm: true
        }
        dispatch({
          type: UserInfoAction.SIGN_IN,
          payload: payload
        })
        dispatch({
          type: UserInfoAction.CLEAR_ERROR,
          payload: {}
        })
      })
      .catch(e => {
        const payload: IUserInfo = {
          loading: false,
          successRegistrationAwaitingConfirm: false
        }
        dispatch({
          type: UserInfoAction.SIGN_IN,
          payload: payload
        })
        if (e.response && e.response.data) {
          if (e.response.data == 'DuplicateUserName') {
            dispatch({
              type: UserInfoAction.ERROR_SIGNIN,
              payload: new Error('Потребителското име вече е заето')
            })
          } else {
            dispatch({
              type: UserInfoAction.ERROR_SIGNIN,
              payload: new Error('Възникна грешка')
            })
          }
        } else {
          dispatch({
            type: UserInfoAction.ERROR_SIGNIN,
            payload: new Error('Възникна грешка')
          })
        }
      })
  }

export const singIn =
  (username: string, password: string) => (dispatch: (data: any) => void, getStore: () => IAppStore) => {
    dispatch({
      type: UserInfoAction.SET_LOADING,
      payload: true
    })
    axios
      .post(appConfig.urls.tokenServiceUrl, {
        Username: username,
        Password: password
      })
      .then(r => {
        const roles = r.data.Roles.map((r: string) => r.toUpperCase())
        const token = r.data.Token
        const base64Url = token.split('.')[1]
        const base64 = base64Url.replace('-', '+').replace('_', '/')
        const decodedToken = JSON.parse(window.atob(base64))
        const expires = new Date(decodedToken.exp * 1000)

        const appUser = {
          token: r.data.Token,
          expires: expires,
          username: r.data.UserName,
          Name: r.data.Name,
          roles: roles,
          lastSignedIn: new Date()
        } as IAppUser
        appUser.isAdmin = roles.indexOf('ADMIN') != -1

        appUser.isRegAdmin = roles.indexOf('REG_ADMIN') != -1 || appUser.isAdmin
        appUser.isCadAdmin = roles.indexOf('CAD_ADMIN') != -1 || appUser.isAdmin
        appUser.isUndAdmin = roles.indexOf('UND_ADMIN') != -1 || appUser.isAdmin
        appUser.isOpuAdmin = roles.indexOf('OPU_ADMIN') != -1 || appUser.isAdmin

        appUser.isArchImportUser = roles.indexOf('ARCHITECT_IMPORT') != -1

        appUser.isArchControl = roles.indexOf('ARCHITECT_CONTROL') != -1 || appUser.isAdmin

        appUser.isPrintUser = roles.indexOf('PRINT_USER') != -1 || appUser.isAdmin

        appUser.isRegViewer = roles.indexOf('REG_VIEWER') != -1 || appUser.isRegAdmin
        appUser.isCadViewer = roles.indexOf('CAD_VIEWER') != -1 || appUser.isCadAdmin
        appUser.isUndViewer = roles.indexOf('UND_VIEWER') != -1 || appUser.isUndAdmin
        appUser.isOpuViewer = roles.indexOf('OPU_VIEWER') != -1 || appUser.isOpuAdmin

        setSession(JSON.stringify(r.data.Token))

        const payload = {
          user: appUser,
          loading: false,
          successRegistrationAwaitingConfirm: false
        } as IUserInfo

        dispatchCredentials(getStore(), dispatch, payload)
      })
      .catch(e => {
        if (e.response && e.response.data) {
          if (e.response.data == 'The user is not active') {
            dispatch({
              type: UserInfoAction.ERROR_SIGNIN,
              payload: new Error('Акаунтът не е активиран от администраторите на сайта')
            })
          } else if (e.response.data == 'Too many login attempts') {
            dispatch({
              type: UserInfoAction.ERROR_SIGNIN,
              payload: new Error('Прекалено много грешни опити. Моля, обърнете се към администратор')
            })
          } else {
            dispatch({
              type: UserInfoAction.ERROR_SIGNIN,
              payload: new Error('Грешно потребителско име или парола')
            })
          }
        } else {
          dispatch({
            type: UserInfoAction.ERROR_SIGNIN,
            payload: new Error('Грешно потребителско име или парола')
          })
        }
      })
  }

let onCompleted: (success: boolean) => void
let interceptor: number
const dispatchCredentials = (store: IAppStore, dispatch: (data: any) => void, payload: IUserInfo) => {
  if (interceptor == null) {
    axios.interceptors.request.eject(interceptor)
  }
  interceptor = axios.interceptors.request.use(
    config => {
      if (config.url && config.url!.indexOf(appConfig.urls.xyApiUrl) != -1) {
        config.headers['Authorization'] = `Bearer ${payload.user!.token}`
      }
      return config
    },
    config => {
      return config
    }
  )
  interval = setInterval(() => {
    if (new Date(payload.user!.expires) <= new Date()) {
      dispatch(signOut())
      if (onCompleted) {
        onCompleted(false)
      }
    }
  }, 10000)
  setCookie('ur', btoa(encodeURIComponent(JSON.stringify(payload))), 1)
  dispatch(appPopupDispatcher.removePopups(['login']))
  if (!store.application.mobile) {
    dispatch(appSidebarDispatcher.setMinimized(false))
  }
  setTimeout(() => {
    ServiceHub.SourcesService.getConfigInfos(payload.user).then(r => {
      dispatch(appSourcesDispatcher.dispatchSources(r))
    })
  }, 400)
  dispatch({
    type: UserInfoAction.SIGN_IN,
    payload: payload
  })
  dispatch({
    type: UserInfoAction.CLEAR_ERROR,
    payload: {}
  })

  if (onCompleted) {
    onCompleted(true)
  }
}

export const tryRecoverCredentials =
  (callback: (success: boolean) => void) => (dispatch: (data: any) => void, getStore: () => IAppStore) => {
    signinCallback = callback
    let credentials = getCookie('ur')
    onCompleted = (success: boolean) => {
      if (!success) {
        eraseCookie('ur', ['/'])
      }
      signinCallback(success)
    }
    if (credentials) {
      credentials = decodeURIComponent(atob(credentials))
      const parsedCredentials = JSON.parse(credentials) as IUserInfo
      if (
        parsedCredentials.user &&
        parsedCredentials.user.expires &&
        new Date(parsedCredentials.user.expires) >= new Date()
      ) {
        dispatchCredentials(getStore(), dispatch, parsedCredentials)
      } else {
        onCompleted(false)
      }
    } else {
      onCompleted(false)
    }
  }

export const signOut = () => (dispatch: (data: any) => void, getStore: () => IAppStore) => {
  axios.interceptors.request.eject(interceptor)
  clearInterval(interval)
  eraseCookie('ur', ['/'])

  dispatch({
    type: UserInfoAction.CLEAR_ERROR,
    payload: {}
  })
  dispatch({
    type: UserInfoAction.SIGN_OUT,
    payload: {}
  })
  dispatch({
    type: DataActions.SET_TABLES_EMPTY,
    payload: {}
  })
  dispatch({
    type: SidebarAction.SET_MINIMIZED,
    payload: true
  })
  dispatch({
    type: SidebarAction.SET_SELECTED,
    payload: 'registers'
  })
  localStorage.clear()
  dispatch(appSourcesDispatcher.clearAllData())
  // reload the page to clear the state
  window.location.reload()
}
